export var isFireFox = function () { return !!window.netscape; };
//# sourceMappingURL=isFireFox.js.map